<div class="login-page">

  <div class="login-header-wrap">
    <app-public-header></app-public-header>
  </div>

  <!-- Body -->
  <main class="login-body">

    <!-- Page Title -->
    <div class="page-title-section">
      <h1 class="page-main-title" *ngIf="currentLang === 'en'">{{t.title}}</h1>
      <h1 class="page-main-title" *ngIf="currentLang === 'or'">{{t.title}}</h1>
      <p class="page-subtitle" *ngIf="currentLang === 'en'">{{loginMode === 'department' ? t.loginModeDepartment :
        t.loginModeRact}}</p>
      <p class="page-subtitle" *ngIf="currentLang === 'or'">{{loginMode === 'department' ? t.loginModeDepartment :
        t.loginModeRact}}</p>
    </div>

    <!-- Login Card -->
    <div class="login-card">
      <div class="form-grid">

        <!-- Form Section -->
        <div class="login-main-section">

          <!-- Official Badge -->
          <div class="official-badge" *ngIf="loginMode === 'department'">
            <mat-icon>gpp_good</mat-icon>
            <span>{{t.officialBadge}}</span>
          </div>

          <!-- Artist Badge -->
          <div class="official-badge" *ngIf="loginMode === 'ract'">
            <mat-icon>gpp_good</mat-icon>
            <span>{{t.ractBadge}}</span>
          </div>

          <h2 class="signin-title">{{ loginMode === 'department' ? t.loginModeDepartment : t.loginModeRact }}</h2>
          <p class="signin-subtitle">{{ t.signinSubtitle }}</p>

          <div class="login-mode-tabs">
            <button type="button" class="mode-tab" [class.active]="loginMode === 'ract'" (click)="setLoginMode('ract')">
              <mat-icon>group</mat-icon>
              <span *ngIf="currentLang === 'en'">{{t.loginModeRact}}</span>
              <span *ngIf="currentLang === 'or'">{{t.loginModeRact}}</span>
            </button>
            <button type="button" class="mode-tab" [class.active]="loginMode === 'department'"
              (click)="setLoginMode('department')">
              <mat-icon>admin_panel_settings</mat-icon>
              <span *ngIf="currentLang === 'en'">{{t.loginModeDepartment}}</span>
              <span *ngIf="currentLang === 'or'">{{t.loginModeDepartment}}</span>
            </button>

          </div>

          <!-- Alerts -->
          <div class="alert-wrapper">
            <app-alerts [currentLang]="currentLang" [showAlert5]="alert.alertType==='error'"
              [alertMessage]="getAlertMessage()"></app-alerts>
            <app-alerts [currentLang]="currentLang" [showAlert4]="alert.alertType==='success'"
              [alertMessage]="getAlertMessage()"></app-alerts>
          </div>

          <form [formGroup]="authForm" (ngSubmit)="onSubmit()">

            <!-- Username -->
            <div class="field-wrapper">
              <label class="field-label">
                {{ t.usernameLabel }}
                <span class="required">*</span>
              </label>
              <mat-form-field appearance="outline" class="login-field">
                <mat-icon matPrefix class="field-icon">person_outline</mat-icon>
                <input matInput type="text" formControlName="username" (input)="onUsernameInput($event)"
                  (blur)="onUsernameBlur()" [placeholder]="t.usernamePlaceholder">
              </mat-form-field>
              <div class="validation-message"
                *ngIf="authForm.get('username')?.hasError('required') && authForm.get('username')?.touched">
                <mat-icon>info</mat-icon>
                <span>{{ t.usernameRequired }}</span>
              </div>
              <div class="validation-message"
                *ngIf="authForm.get('username')?.hasError('pattern') && authForm.get('username')?.touched">
                <mat-icon>info</mat-icon>
                <span>{{ t.usernameInvalid }}</span>
              </div>
              <div class="validation-message"
                *ngIf="authForm.get('username')?.hasError('invalidFormat') && authForm.get('username')?.touched">
                <mat-icon>info</mat-icon>
                <span>{{ t[authForm.get('username')?.getError('invalidFormat')] ||
                  authForm.get('username')?.getError('invalidFormat') }}</span>
              </div>
            </div>

            <!-- Password -->
            <div class="field-wrapper">
              <label class="field-label">{{t.passwordLabel}} <span class="required">*</span></label>
              <mat-form-field appearance="outline" class="login-field">
                <mat-icon matPrefix class="field-icon">lock_outline</mat-icon>
                <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" (blur)="onPasswordBlur()"
                  (input)="onPasswordInput()" [placeholder]="t.passwordPlaceholder">
                <button mat-icon-button matSuffix (click)="hide = !hide" type="button" class="eye-btn">
                  <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
              </mat-form-field>
              <div class="validation-message"
                *ngIf="authForm.get('password')?.hasError('required') && authForm.get('password')?.touched">
                <mat-icon>info</mat-icon><span>{{t.passwordRequired}}</span>
              </div>
              <div class="validation-message"
                *ngIf="authForm.get('password')?.hasError('minlength') && authForm.get('password')?.touched && authForm.get('password')?.value">
                <mat-icon>info</mat-icon><span>{{t.passwordMinlength}}</span>
              </div>
              <div class="validation-message"
                *ngIf="authForm.get('password')?.hasError('invalidFormat') && authForm.get('password')?.touched">
                <mat-icon>info</mat-icon><span>{{ t[authForm.get('password')?.getError('invalidFormat')] ||
                  authForm.get('password')?.getError('invalidFormat') }}</span>
              </div>
            </div>

            <!-- Captcha -->
            <div class="field-wrapper" style="margin-bottom: 16px;">
              <label class="field-label">
                {{ currentLang === 'or' ? 'ସୁରକ୍ଷା ଯାଞ୍ଚ (କ୍ୟାପଚା)' : 'Security Check (CAPTCHA)' }}
                <span class="required">*</span>
              </label>
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">
                <div
                  style="display: flex; align-items: center; background: #fff; border: 1px solid #ccc; border-radius: 6px; overflow: hidden; height: 42px;">
                  <img [src]="captchaUrl" alt="captcha"
                    style="height: 100%; width: 120px; object-fit: contain; background: #fff;" />
                  <button type="button" (click)="refreshCaptcha()"
                    style="background: #f8f9fa; border: none; border-left: 1px solid #ccc; padding: 0 10px; height: 100%; cursor: pointer; color: #555;"
                    title="Refresh Captcha">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px;">refresh</mat-icon>
                  </button>
                </div>
                <mat-form-field appearance="outline" class="login-field" style="flex: 1; margin-bottom: 0;">
                  <mat-icon matPrefix class="field-icon">verified_user</mat-icon>
                  <input matInput type="text" formControlName="captcha"
                    [placeholder]="currentLang === 'or' ? 'ଯୋଗଫଳ ପ୍ରବେଶ କରନ୍ତୁ' : 'Enter sum'" autocomplete="off" />
                </mat-form-field>
              </div>
              <div class="validation-message"
                *ngIf="authForm.get('captcha')?.hasError('required') && authForm.get('captcha')?.touched">
                <mat-icon>info</mat-icon>
                <span>{{ currentLang === 'or' ? 'ଦୟାକରି କ୍ୟାପଚା ପ୍ରବେଶ କରନ୍ତୁ |' : 'CAPTCHA code is required.' }}</span>
              </div>
            </div>

            <div class="forgot-row">
              <a routerLink="/forgot-password" class="forgot-link">{{t.forgotPassword}}</a>
            </div>

            <p class="password-notice">{{t.passwordNotice}}</p>

            <!-- Submit -->
            <button mat-raised-button type="submit" [disabled]="authForm.invalid || isLoading" class="submit-btn">
              <mat-icon *ngIf="!isLoading">lock</mat-icon>
              <mat-spinner *ngIf="isLoading" diameter="20" class="btn-spinner" style="margin-right: 8px;"></mat-spinner>
              <span *ngIf="!isLoading">{{t.signInBtn}}</span>
              <span *ngIf="isLoading">Signing in...</span>
            </button>

          </form>

          <!-- Trust Badges -->
          <div class="trust-badges">
            <span class="trust-item">
              <mat-icon>lock</mat-icon> {{t.sslSecured}}
            </span>
            <span class="trust-divider">|</span>
            <span class="trust-item">
              <mat-icon>verified</mat-icon> {{t.officialGovtPortal}}
            </span>
            <span class="trust-divider">|</span>
            <span class="trust-item">
              <mat-icon>security</mat-icon> {{t.encrypted}}
            </span>
          </div>

          <!-- Back to Home -->
          <div class="back-home">
            <a routerLink="/" class="back-home-link">
              <mat-icon>arrow_back</mat-icon>
              <span>{{t.backToHome}}</span>
            </a>
          </div>

        </div>

        <!-- Sidebar -->
        <div class="form-sidebar">

          <!-- Official Verification -->
          <div class="info-card verification-card">
            <div class="card-head">
              <span class="card-icon-wrap green">
                <mat-icon>gpp_good</mat-icon>
              </span>
              <span>{{t.verificationTitle}}</span>
            </div>
            <p>{{t.verificationDesc}}</p>
          </div>

          <!-- Need Help -->
          <div class="info-card help-card">
            <div class="card-head">
              <span class="card-icon-wrap blue">
                <mat-icon>support_agent</mat-icon>
              </span>
              <span>{{t.needHelpTitle}}</span>
            </div>
            <p class="help-intro">{{t.needHelpDesc}}</p>
            <div class="contact-row">
              <span class="contact-icon-wrap">
                <mat-icon>phone</mat-icon>
              </span>
              <span>+91 63729 01907</span>
            </div>
            <div class="contact-row">
              <span class="contact-icon-wrap">
                <mat-icon>mail_outline</mat-icon>
              </span>
              <span>directorateofculture@gmail.com</span>
            </div>
            <button class="btn-helpdesk" routerLink="/contact-us">{{t.contactHelpdesk}}</button>
          </div>

          <!-- Administrative Support -->
          <div class="info-card admin-card">
            <div class="card-head">
              <span class="card-icon-wrap blue">
                <mat-icon>admin_panel_settings</mat-icon>
              </span>
              <span>{{t.adminSupportTitle}}</span>
            </div>
            <p>{{t.adminSupportDesc}}</p>
          </div>

        </div>
      </div>
    </div>

  </main>

  <!-- Footer -->
  <footer class="login-footer">
    <span class="footer-copy">{{t.footerCopy}}</span>
    <div class="footer-links">
      <a routerLink="/privacy-policy">{{t.privacyPolicy}}</a>
      <a routerLink="/terms-of-service">{{t.termsOfService}}</a>
    </div>
  </footer>

</div>